import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";
import { BRAND, LOGO_URL } from "../lib/brand";
import { FOOTER } from "../lib/testIds";

export const Footer = () => {
    return (
        <footer
            data-testid={FOOTER.root}
            className="relative z-10 mt-24 border-t border-[#2e3220]/10 bg-[#E8E2D0]/40"
        >
            <div className="mx-auto grid max-w-7xl gap-10 px-6 py-12 md:grid-cols-4 md:px-10">
                <div className="md:col-span-2">
                    <Link to="/" className="flex items-center gap-3" aria-label="Lendly home">
                        <img
                            src={LOGO_URL}
                            alt="Lendly"
                            className="h-10 w-10 rounded-xl object-cover"
                        />
                        <span className="font-display text-2xl font-bold text-[#2e3220]">
                            {BRAND.name}
                        </span>
                    </Link>
                    <p className="mt-4 max-w-md text-sm leading-relaxed text-[#5a6142]">
                        {BRAND.description}
                    </p>
                    <div className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#737a3d]/10 px-3 py-1 text-xs font-bold uppercase tracking-widest text-[#737a3d]">
                        <Leaf className="h-3.5 w-3.5" />
                        Built for neighbors in Easton Park
                    </div>
                </div>

                <div>
                    <h4 className="font-display text-sm font-bold uppercase tracking-widest text-[#737a3d]">
                        Marketplace
                    </h4>
                    <ul className="mt-4 space-y-2 text-sm text-[#2e3220]/80">
                        <li>
                            <Link to="/browse" className="hover:text-[#737a3d]">
                                Browse items
                            </Link>
                        </li>
                        <li>
                            <Link to="/list" className="hover:text-[#737a3d]">
                                List an item
                            </Link>
                        </li>
                        <li>
                            <Link to="/how-it-works" data-testid="footer-how-it-works" className="hover:text-[#737a3d]">
                                How it works
                            </Link>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-display text-sm font-bold uppercase tracking-widest text-[#737a3d]">
                        You
                    </h4>
                    <ul className="mt-4 space-y-2 text-sm text-[#2e3220]/80">
                        <li>
                            <Link to="/dashboard/rentals" className="hover:text-[#737a3d]">
                                Borrowing
                            </Link>
                        </li>
                        <li>
                            <Link to="/dashboard/listings" className="hover:text-[#737a3d]">
                                Lending
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-[#2e3220]/10 px-6 py-5 text-center text-xs text-[#5a6142] md:px-10">
                © {new Date().getFullYear()} {BRAND.name}. Made with care by your neighbor.
            </div>
        </footer>
    );
};

export default Footer;
